import { render } from "./KidsClassesPage.vue?vue&type=template&id=68e4e1e7"
import script from "./KidsClassesPage.vue?vue&type=script&lang=js"
export * from "./KidsClassesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__